import ArrowIcon from "../Icons/ArrowIcon";
import ShareIcon from "../Icons/ShareIcon";
import StarIcon from "@mui/icons-material/Star";

const ProjectCardContent = ({
  project,
  onOpen,
  forProfile,
}: {
  project: any;
  onOpen: () => void;
  forProfile?: boolean;
}) => {
  return (
    <div className="project-card-content">
      <div
        className={`project-card-content__items padding-${
          forProfile ? "large" : "small"
        }`}
      >
        {project?.feedback && !forProfile && (
          <div className="project-card-content__box">
            <h6>{project.feedback}</h6>
            <StarIcon />
          </div>
        )}

        <div className="project-card-content__item">
          <h6 className="subtitle-3">{project.title}</h6>

          <div className="project-card-content__icon pointer">
            <a
              href="mailto:info@dronecakes.com"
              style={{ display: "flex", alignItems: "center" }}
            >
              <ShareIcon color="#4D4E4E" />
            </a>
          </div>
        </div>
        <div className="project-card-content__item">
          <div className="project-card-content__box">
            <h6>{project.skills[0]}</h6>
          </div>

          <div
            className="project-card-content__icon pointer"
            onClick={onOpen}
            children={<ArrowIcon type="right" color="#1C1C1C" />}
          />
        </div>
      </div>
    </div>
  );
};

export default ProjectCardContent;
